<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded"><span class="epub-i">In loving memory of</span></p>
<p class="ded"><span class="epub-i">ROBERT SIMPSON</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?973fc700